import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

export default function LogoutHandler() {
  const auth = useAuth();

  useEffect(() => {
    auth.signOut(); // side effect
  }, []);

  // redirect after sign out
  return <Navigate to="/login" replace />;
}
